import {
    UIBridgeSubsystem,
    VisionClient,
    NetworkSubsystem,
    VisionEvents
} from '@akavirtual/deai-web-core';


export class CollaborationUIBridge extends UIBridgeSubsystem {
    public initialize(client: VisionClient): void {
        super.initialize(client);
        this.on(VisionEvents.AGENT_CONNECTED, this.handleAgentConnected.bind(this));
        this.on(VisionEvents.AGENT_DISCONNECTED, this.handleAgentDisconnected.bind(this));
    }

    private handleAgentConnected() {
        this.emit(VisionEvents.GAME_READY);
    }
    
    private handleAgentDisconnected() {
        this.emit(VisionEvents.GAME_RESET);
    }

    public destroy(): void {

        super.destroy();
    }
}